import React from 'react';
import './OnboardingSteps.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

const Step = ({ number, title, children }) => (
  <li>
    <span className="fa-stack" aria-hidden="true">
      <FontAwesomeIcon icon={faCircle} className="fa-stack-2x" style={{ color: '#482c80' }} />
      <span className="fa-stack-1x step-number">{number}</span>
    </span>
    <div className="step-content">
      <h2 className="font-armata step-title">{title}</h2>
      <p className="step-description">{children}</p>
    </div>
  </li>
);

const OnboardingSteps = () => (
  <section id="onboarding__container" aria-labelledby="journey-heading">
    <div id="onboarding">
      <h1 id="journey-heading" className="font-armata journey-heading">
        Your Journey to Better Health Starts Here
      </h1>

      <div className="onboarding__onecol">
        <div className="steps">
          <ol className="custom-numbered-list">
            <Step number="1" title="Schedule Your Session">
              Select a convenient time below that works best for you.
            </Step>
            <Step number="2" title="Log in to your Patient Portal">
              Create a password and log in to manage appointments and receive secure messages.
            </Step>
            <Step number="3" title="Complete Your Intake Forms">
              Get your forms in at least 24 hours before your appointment.
            </Step>
          </ol>
        </div>

        <p className="onboarding__note">
          A recent mammogram is required for hormone replacement therapy — either completed within the past two years or scheduled within the next 90 days.
        </p>
      </div>
    </div>
  </section>
);

export default OnboardingSteps;
